import ImgMenu1 from './../../assets/img/menu/menu1.jpg' 
import ImgMenu2 from './../../assets/img/menu/menu2.jpg' 
import ImgMenu3 from './../../assets/img/menu/menu3.jpg' 
import ImgMenu4 from './../../assets/img/menu/menu4.jpg' 
import ImgMenu5 from './../../assets/img/menu/menu5.jpg' 
import ImgMenu6 from './../../assets/img/menu/menu6.jpg' 

export const Dish = [
  {
    id: 1,
    title: 'Menú 1',
    img: ImgMenu1,
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas, exercitationem voluptate necessitatibus voluptates pariatur sint minus omnis numquam quibusdam dolorem ea qui harum nemo.',
    price: 'Bs. 70'
  },
  {
    id: 2,
    title: 'Menú 2',
    img: ImgMenu2,
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas, exercitationem voluptate necessitatibus voluptates pariatur sint minus omnis numquam quibusdam dolorem ea qui harum nemo.',
    price: 'Bs. 40'
  },
  {
    id: 3,
    title: 'Menú 3',
    img: ImgMenu3,
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas, exercitationem voluptate necessitatibus voluptates pariatur sint minus omnis numquam quibusdam dolorem ea qui harum nemo.',
    price: 'Bs. 20'
  },
  {
    id: 4,
    title: 'Menú 4',
    img: ImgMenu4,
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas, exercitationem voluptate necessitatibus voluptates pariatur sint minus omnis numquam quibusdam dolorem ea qui harum nemo.',
    price: 'Bs. 40'
  },
  {
    id: 5,
    title: 'Menú 5',
    img: ImgMenu5,
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas, exercitationem voluptate necessitatibus voluptates pariatur sint minus omnis numquam quibusdam dolorem ea qui harum nemo.',
    price: 'Bs. 150'
  },
  {
    id: 6,
    title: 'Menú 6',
    img: ImgMenu6,
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas, exercitationem voluptate necessitatibus voluptates pariatur sint minus omnis numquam quibusdam dolorem ea qui harum nemo.',
    price: 'Bs. 25'
  }
]